import React from "react";
import { CheckboxInput } from "@streeteasy/design-system/form";
import { bool, func, string } from "prop-types";

import * as S from "../../styled";

const AmenityItem = ({
  handleAmenitySelection,
  imgSrc,
  isChecked,
  name,
  value
}) => (
  <S.AmenityItem>
    <S.Img alt="" loading="lazy" src={imgSrc} />
    <S.CheckboxWrapper>
      <CheckboxInput
        checked={isChecked}
        label={value}
        name={name}
        onChange={handleAmenitySelection}
        value={value}
      />
    </S.CheckboxWrapper>
  </S.AmenityItem>
);

AmenityItem.propTypes = {
  handleAmenitySelection: func.isRequired,
  imgSrc: string.isRequired,
  isChecked: bool.isRequired,
  name: string.isRequired,
  value: string.isRequired
};

export default AmenityItem;
